<template>
  <footer class="footer">
    <div class="site-footer">
      <div class="footer-logo">
        <div class="logo-img">
          <img src="../image/web/footer/yuntu-logo.png"/>
        </div>
        <div class="footer-contact">
          <p>总机：010-82330986</p>
          <p>电话：400-010-0986</p>
          <p>传真：010-82311350</p>
          <p>地址：北京市海淀区西三旗新龙大厦B座11层</p>
        </div>
      </div>
      <div class="footer-links">
        <dl
          class="col-links"
          v-for="item in nevigatelist"
          :_t_nav="item.nav"
          :key="item.id"
          @click="selectNav(item.id, item.path)"
          :class="{'title-active':item.active}"
        >
          <dt>{{ item.label }}</dt>
          <dd v-for="children in item.child" :key="children.id">
            <span @click="goPage(children.path)">{{ children.label }}</span>
          </dd>
        </dl>
      </div>
      <div class="footer-code">
        <div class="code-img">
          <img src="../image/web/footer/scan-code.jpg" />
        </div>
        <p>扫一扫关注</p>
        <p>信德过微信公众号</p>
      </div>
    </div>
    <div class="site-info">
      <div class="container">
        <div class="info-text">
          <p>
            运营单位：北京鑫创数字科技股份有限公司
            <span style="margin-left: 25px"
              >备案号：<a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                style="color: #dbdbdb !important"
                >京ICP备10026580号-9</a
              ></span
            >
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      nevigatelist: [
        {
          id: "0",
          path: "/",
          label: "首页",
          active:true,
        },
        {
          id: "1",
          nav: "digital-products",
          label: "数字产品服务",
          active:false,
          child: [
            {
              id: "1-1",
              path: "/index/digitalTraceability",
              label: "防伪追溯服务",
            },
            {
              id: "1-8",
              path: "/index/signMaking",
              label: "标识制作服务",
            },
            {
              id: "1-2",
              path: "/index/fleeingGoods",
              label: "防窜货服务",
            },
            {
              id: "1-3",
              path: "/index/digitalMarketing",
              label: "数字营销",
            },
            {
              id: "1-4",
              path: "/index/codingService",
              label: "赋码服务",
            },
            {
              id: "1-5",
              path: "/index/dataApply",
              label: "大数据分析服务",
            },
            {
              id: "1-6",
              path: "/index/secondNode",
              label: "二级节点解析服务",
            },
            {
              id: "1-7",
              path: "/index/more",
              label: "更多服务",
            },
          ],
        },
        {
          id: "2",
          nav: "industry-solutions",
          label: "行业解决方案",
          active:false,
          child: [
            {
              id: "2-1",
              path: "/index/salt",
              label: "食盐行业",
            },
            {
              id: "2-2",
              path: "/index/huafei",
              label: "化肥行业",
            },
            {
              id: "2-3",
              path: "/index/yurong",
              label: "羽绒行业",
            },
            {
              id: "2-4",
              path: "/index/kuaixiaopin",
              label: "快消品行业",
            },
            {
              id: "2-5",
              path: "/index/others",
              label: "更多行业",
            },
          ],
        },
        {
          id: "3",
          nav: "bigdata-analytics",
          label: "服务对象",
          active:false,
          child: [
            {
              id: "3-1",
              path: "/index/business",
              label: "大型、中小微企业",
            },
            {
              id: "3-2",
              path: "/index/government",
              label: "政府、协会等机构",
            },
            {
              id: "3-3",
              path: "/index/consumer",
              label: "亿万消费者",
            },
          ],
        },
        {
          id: "4",
          path: "/index/cooperation",
          nav: "cooperation",
          label: "合作案例",
          active:true,
        },
        {
          id: "5",
          path: "/index/news",
          nav: "news",
          label: "新闻资讯",
          active:true,
        },
        {
          id: "6",
          path: "/index/aboutUs",
          nav: "about-us",
          label: "关于我们",
          active:true,
        },
      ],
    };
  },
  methods: {
    selectNav(id, path) {
      window.scrollTo(0, 0);
      this.isNavSelected = id;
      if (path) {
        this.$router.push(path);
      }
    },
    goPage(path) {
      this.$router.push({
        path: path,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  width: 100%;
  background-color: #434343;
  min-width: 1220px;
  .site-footer {
    width: 1220px;
    margin: 0 auto;
    display: flex;
    .footer-logo {
      width: 320px;
      .logo-img {
        // text-align: center;
        padding-top: 30px;
        img {
          width: 200px;
        }
      }
      .footer-contact {
        font-size: 14px;
        font-weight: bold;
        color: #f0f0f0;
        line-height: 24px;
        margin-top: 30px;
      }
    }
    .footer-links {
      display: flex;
      width: 700px;
      justify-content: space-between;
      padding-top: 20px;
      line-height: 24px;
      .col-links {
        dt {
          font-size: 16px;
          color: #ffffff;
          margin-bottom: 10px;
        }
        dd {
          font-size: 14px;
          color: #c7c7c7;
          cursor: pointer;
        }
      }
    }
    .footer-code {
      width: 200px;
      text-align: center;
      margin-top: 20px;
      p {
        font-size: 16px;
        color: #c7c7c7;
        line-height: 24px;
      }
    }
    .title-active{
      cursor: pointer;
    }
    // .container {
    //   width: 1220px;
    //   margin-right: auto;
    //   margin-left: auto;

    //   .footer-service {
    //     padding: 30px 0 27px 0;
    //     border-bottom: 1px solid #595959;

    //     ul {
    //       display: flex;
    //       justify-content: space-between;

    //       li {
    //         display: inline-block;
    //       }
    //     }
    //   }

    //   .footer-links {
    //     padding: 25px 0;
    //     overflow: hidden;
    //     border-bottom: 1px solid #595959;
    //     display: flex;
    //     justify-content: space-between;
    //     .col-links {
    //       // width: 140px;

    //       dt {
    //         margin-bottom: 10px;
    //         font-size: 16px;
    //         line-height: 1.25;
    //         color: #ffffff;
    //         cursor: pointer;
    //       }

    //       dd {
    //         margin: 2px 0 0;
    //         font-size: 14px;

    //         span {
    //           color: #9d9d9d;
    //           cursor: pointer;
    //         }
    //       }
    //     }

    //     .col-contact {
    //       float: right;
    //       img {
    //         width: 100px;
    //       }
    //       dt {
    //         margin-bottom: 10px;
    //         font-size: 16px;
    //         line-height: 1.25;
    //         color: #ffffff;
    //       }

    //       p {
    //         font-size: 12px;
    //         color: #9d9d9d;
    //       }
    //     }
    //   }
    // }
  }

  .site-info {
    padding: 25px 0 30px 0;
    font-size: 12px;

    .container {
      position: relative;
      width: 1220px;
      margin-right: auto;
      margin-left: auto;
      display: flex;
      justify-content: center;
      .info-text {
        color: #dbdbdb;
        font-size: 16px;
        p {
          margin-top: 2px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/webSiteFooter.vue